export { default as IViewDetails } from './IViewDetails'
